import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useBarometerBidOptions() {
  const { startListen } = useWebSocketStore()
  const { updateBarometerCarData } = useUpdateCar()

  const bidOptions = () => {
    startListen({
      eventName: 'premium.BID_OPTIONS',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, options: bidOptions } = event.context
        updateBarometerCarData('unknown', carId, (data) => {
          return {
            ...data,
            bidOptions,
          }
        })
      },
    })
  }

  return { bidOptions }
}
